<template>
    <section class="c-header-nav-links">
        <div v-for="group in navigation" :key="group.key" class="c-header-nav-links__group">
            <p class="c-header-nav-links__label t-t4-heavy-bold">{{ group.label }}</p>
            <ul class="c-header-nav-links__inner">
                <app-header-nav-links-item
                    v-for="navLink in group.links"
                    :key="navLink.path"
                    :nav-link="navLink"
                />
            </ul>
        </div>
    </section>
</template>

<script>
    import { routes } from "src/router";
    import AppHeaderNavLinksItem from "components/AppHeader/AppHeaderNav/AppHeaderNavLinks/AppHeaderNavLinksItem";
    export default {
        components: {
            AppHeaderNavLinksItem,
        },
        computed: {
            navigation() {
                return [
                    {
                        key: "info",
                        label: this.$t("nav.info"),
                        links: ["places", "facts"].map((name) => this.link(name)),
                    },
                    {
                        key: "campaigns",
                        label: this.$t("nav.campaigns"),
                        links: ["campaign_2025", "campaign_2024", "campaign_2022", "campaign_2021", "economies"].map((name) => this.link(name)),
                    },
                ];
            },
        },
        methods: {
            link(name) {
                const route = routes.find((item) => item.name === name);
                const page = this.$store.getters["global/getPageByHandle"](route.meta.prismicHandle);
                const title = page.data.label || page.data.title;
                return { path: route.path, title, isExternal: false };
            },
        },
    };
</script>

<style lang="scss">
    .c-header-nav-links {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: var(--grid-gutter);
        height: 100%;

        @media #{$breakpoint-horizontal} {
            gap: var(--grid-gutter-double);
        }

        &__label {
            margin-bottom: var(--grid-gutter-half);
            font-size: 1em;
            opacity: 0;
            @include transform(translate(0px, 50px));

            @media #{$breakpoint-horizontal} {
                padding-left: var(--grid-gutter-double);
                font-size: 1.2em;
            }
        }

        &__inner {
            @include reset-list;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
    }
</style>
